export enum SchoolType {
  Public = 'Public',
  Independent = 'Independent',
  Selective = 'Selective',
  International = 'International',
  Other = 'Other',
}

export const SCHOOL_TYPE_LABELS: Record<SchoolType, string> = {
  [SchoolType.Public]: 'Public',
  [SchoolType.Independent]: 'Independent',
  [SchoolType.Selective]: 'Selective',
  [SchoolType.International]: 'International',
  [SchoolType.Other]: 'Other',
};
